import {BrowserRouter, Routes,Route} from "react-router-dom"
import './App.css';
import Home from "./pages/Home";
import Page404 from "./pages/Page404";
import Header from "./components/Header";
import MoviesInfoPage from "./pages/MoviesInfoPage";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Movies/:id" element={<MoviesInfoPage />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
